import { Component, Inject, OnInit } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { APP_STORE_CONFIG_TOKEN } from '@ddt-web/config';
import { AppStoreConfig } from '@ddt-web/data-service';
import { DialogService } from '@ddt-web/dialog';
import { DialogIcon } from '@ddt-web/domain';
import { StoreService } from '@ddt-web/store-service';
import { UrlService } from '@ddt-web/url';
import { PartnerConstants } from '@ddt-web/user-data';
import * as get from 'lodash/get';
import { Observable, of } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { EntityFlags } from '../utils/entity-flags';
import { PartnerPortfolioFlagUtils } from '../utils/partner-portfolio-flag-utils';

@Component({
	selector: 'pi-unsupported-import-dialog',
	templateUrl: './unsupported-import-dialog.component.html',
	styleUrls: ['./unsupported-import-dialog.component.scss']
})
export class UnsupportedImportDialogComponent implements OnInit {

	public singleErrorView: boolean = false;
	public hasUnsupportedSleeves: boolean = false;
	public hasUnsupportedSecurities: boolean = false;
	public hasSubstitutedAssetClass: boolean = false;
	public imagePath: string;
	public dialogTitle: string;
	public ids$: Observable<any>;

	constructor(
		@Inject(APP_STORE_CONFIG_TOKEN) private storeConfig: AppStoreConfig,
		private contentService: ContentService,
		private dialogService: DialogService,
		private storeService: StoreService,
		private urlService: UrlService
	) { }

	public ngOnInit(): void {
		this.dialogTitle = this.contentService.get('UNSUPPORTED_IMPORT_TITLE', 'Before you analyze your Model,<br />it will need to be adjusted.');
		const portfolioId = this.urlService.getFirstPortfolioId()[0];
		this.ids$ = of([portfolioId]);
		this.storeService
			.selectById(this.storeConfig.associatedPortfolios, portfolioId)
			.pipe(
				first(portfolio => get(portfolio, portfolioId)),
				map(portfolio => get(portfolio, portfolioId))
			)
			.subscribe(portfolio => {
				if (portfolio) {
					const portfolioFlags: EntityFlags = get(portfolio, PartnerConstants.PARTNER_PORTFOLIO_FLAGS.KEY);
					this.hasUnsupportedSleeves = PartnerPortfolioFlagUtils.hasUnsupportedSleeves(portfolioFlags);
					this.hasUnsupportedSecurities = PartnerPortfolioFlagUtils.hasUnsupportedSecurities(portfolioFlags);
					this.hasSubstitutedAssetClass = PartnerPortfolioFlagUtils.hasAssetClassSubstitutions(portfolioFlags);
					this.initViewType();
					if (this.singleErrorView) {
						this.imagePath = DialogIcon.EXCLAMATION_TRIANGLE;
					}
				}
			});
	}

	/**
	 *
	 *
	 * @private
	 * @memberof UnsupportedImportDialogComponent
	 */
	private initViewType(): void {
		if ((this.hasUnsupportedSleeves && !(this.hasSubstitutedAssetClass || this.hasUnsupportedSecurities))
			|| (this.hasUnsupportedSecurities && !(this.hasUnsupportedSleeves || this.hasSubstitutedAssetClass))) {
			this.singleErrorView = true;
			if (this.hasUnsupportedSleeves) {
				this.dialogTitle = this.contentService.get('SLEEVE_REPLACE_TITLE', 'The following sleeves cannot be analyzed.');
			} else if (this.hasUnsupportedSecurities) {
				this.dialogTitle = this.contentService.get('SECURITIES_REPLACE_TITLE', 'The following securities cannot be analyzed.');
			}
		}
	}

	public onContinue(): void {
		this.dialogService.close();
	}
}
